import type { Logger } from '@puzzlemania/shared';

/**
 * Catches errors ErrorBoundary can't — thrown outside React's render cycle (a
 * setTimeout, a Promise, PixiJS's own render loop). Always logs, never just
 * swallows. Returns an unregister function for cleanup (tests, hot reload).
 */
export function registerGlobalErrorHandlers(logger: Logger): () => void {
  const onError = (event: ErrorEvent): void => {
    logger.error(`Uncaught error: ${event.message}`, event.error);
  };
  const onRejection = (event: PromiseRejectionEvent): void => {
    logger.error('Unhandled promise rejection', event.reason);
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);

  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}
